/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { 
	CREATE_PENALIZE_DIALOG_FORM_PROPS, 
	EDIT_PENALIZE_DIALOG_FORM_PROPS, 
	INIT_FORM, 
	PENALTY_DETAILS_MAX_LENGTH 
} from "../constants";

const usePenalizeForm = ({
	dialogPenalizeForm,
	currentPenalty
}) => {
	const [penalizeForm, setPenalizeForm] = useState({ ...INIT_FORM });
	const [renderData, setRenderData] = useState({
        title: "",
        subtitle: "",
        confirm: ""
    });
	useEffect(() => {
        if (!dialogPenalizeForm.value) return;
		setupForm();
    }, [dialogPenalizeForm.value]);
	//#region Functions
	function setupForm() {
        if (!currentPenalty) {
			setRenderData(CREATE_PENALIZE_DIALOG_FORM_PROPS);
			setPenalizeForm({ ...INIT_FORM });
			return;
        }
		setRenderData(EDIT_PENALIZE_DIALOG_FORM_PROPS);
		setPenalizeForm({ ...currentPenalty });
	}
	function setField(field, value) {
		setPenalizeForm(prev => ({
            ...prev,
			[field]: value
        }));
    }
	function setDetails(value) {
		setField("details", value);
	}
	function setReasonForPenalizeId(value) {
		setField("reasonForPenalizeId", value);
	}
	function setPenalizeDays(value) {
		setField("penalizeDays", value);
	}
	function isCompletedForm() {
        const { details, reasonForPenalizeId, penalizeDays } = penalizeForm;
        return (!details || details.length <= PENALTY_DETAILS_MAX_LENGTH) && reasonForPenalizeId && parseInt(penalizeDays) > 0;
    }
	function areThereChangesWhenIsUpdate() {
        if (currentPenalty === null) return true;
        const { details, penalizeDays } = penalizeForm;
        return (
            details !== currentPenalty.details || penalizeDays !== currentPenalty.penalizeDays
        );
    }
	//#endregion
	return {
		value: penalizeForm,
		isCompleted: isCompletedForm,
		areThereChangesWhenIsUpdate,
		setDetails,
		setReasonForPenalizeId,
		setPenalizeDays,
		renderData
	};
}	
	
export default usePenalizeForm;